// module imports
import React from 'react';
interface BaseTableItem {
  _id?: string;
}
interface TableColumn<T extends BaseTableItem = BaseTableItem> {
  key: keyof T | string;
  label: string;
  render?: (item: T) => React.ReactNode;
}
interface DataTableProps<T extends BaseTableItem = BaseTableItem> {
  data: T[];
  columns: TableColumn<T>[];
  emptyMessage?: string;
  className?: string;
}

export default function DataTable<T extends BaseTableItem>({ data = [], columns, emptyMessage = 'No data found.', className = '' }: DataTableProps<T>) {
  return (
    <div className={`overflow-x-auto bg-white rounded shadow ${className}`}>
      <table className="w-full min-w-max text-sm table-auto">
        <thead className="bg-blue-100 text-left font-semibold text-gray-700">
          <tr>
            {columns.map((column) => (
              <th key={String(column.key)} className="p-2 sm:p-3 whitespace-nowrap">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="p-8 text-center text-gray-500">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr key={item._id ?? index} className="border-b border-gray-100 hover:bg-gray-50">
                {columns.map((column) => (
                  <td key={String(column.key)} className="p-2 sm:p-3 whitespace-nowrap">
                    {column.render ? column.render(item) : String((item as any)[column.key] ?? '')}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
